import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'games-overlay',
  templateUrl: './games-overlay.component.html',
  styleUrls: ['./games-overlay.component.css']
})
export class GamesOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
